import { createContext, useContext } from 'react'

// Единый сайдбар: раздел-страница (напр. Карты) отдаёт свои инструменты в общий
// рельс через портал в этот DOM-слот. null → слот не смонтирован (свёрнутый рельс).
export const RailSlotContext = createContext<HTMLElement | null>(null)

export function useRailSlot(): HTMLElement | null {
  return useContext(RailSlotContext)
}
